module.exports = __webpack_public_path__ + "img/menu-black.c68546b7.svg";